import type { DecisionRecord } from "@/engine/types";
import { metricLabel } from "./MetricBar";

function EffectChips({ effects }: { effects: DecisionRecord["effects"] }) {
  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {effects.map((e, i) => (
        <span
          key={i}
          className={`text-[10px] font-mono px-1.5 py-0.5 rounded ${
            e.delta >= 0 ? "bg-emerald-500/10 text-emerald-600" : "bg-red-500/10 text-red-500"
          }`}
        >
          {metricLabel(e.metric)} {e.delta >= 0 ? "+" : ""}
          {e.delta}
        </span>
      ))}
    </div>
  );
}

export default function DecisionLog({ history }: { history: DecisionRecord[] }) {
  return (
    <div className="space-y-2">
      {history.map((h, i) => (
        <div key={i} className="text-[11px] font-body">
          <span className="text-muted-foreground font-mono">Day {h.day}: </span>
          <span className="text-card-foreground">{h.choiceText}</span>
        </div>
      ))}
    </div>
  );
}

export { EffectChips };
